var OccurenceStatus = /** @class */ (function () {
    function OccurenceStatus(id, name, updateDateTime, activeStatusIndicator) {
        this.id = id;
        this.name = name;
        this.updateDateTime = updateDateTime;
        this.activeStatusIndicator = activeStatusIndicator;
    }
    return OccurenceStatus;
}());
export { OccurenceStatus };
